import {dateTimeOptions} from '../../../settings/humanum';

export const localizedDate = function (date: number, lang?: string): string {
    return new Date(date * 1000).toLocaleDateString(lang ? lang : navigator.language, dateTimeOptions);
};